import React from "react";
import Switch from "react-switch";

export const Toggle = (props) => {
  return (
    <>
      <Switch
        onChange={props.toggleFunction}
        checked={props.checked}
        className="react-switch"
        disabled={props.disabled}
        height={23}
        width={46}
      />
    </>
  );
};

export const DisabledToggle = (props) => {
  return (
    <>
      <Switch
        onChange={() => {}}
        checked={props.checked}
        className="react-switch"
        // disabled
        height={23}
        width={46}
      />
    </>
  );
};
